import React, { createContext, useContext, useState } from 'react'
import FiltersHojaVida from '../hooks/filters/FiltersHojaVida'

export const ContextFilterHojaVida = createContext()


export const ContextFilterHojaVidaProvider = ({ children }) => {
    const { filtered, handleFilter, onChangeSerial } = FiltersHojaVida()
    return (
        <ContextFilterHojaVida.Provider value={{ filtered, handleFilter, onChangeSerial }}>
            {children}
        </ContextFilterHojaVida.Provider>
    )
}
export const useContextFilterHojaVidaProvider = () => {
    return useContext(ContextFilterHojaVida)
}